
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireecd3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireecd3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("eBhjS", function(module, exports) {
module.exports = new URL("time-2.fb93ff21.png", import.meta.url).toString();

});

parcelRegister("bHJUT", function(module, exports) {
module.exports = new URL("another-npc.cb713ed6.png", import.meta.url).toString();

});

parcelRegister("3UKTR", function(module, exports) {
module.exports = new URL("soup.d80ca473.png", import.meta.url).toString();

});

parcelRegister("iQrU4", function(module, exports) {
module.exports = new URL("the-wheel-of-fortune.268f82f2.png", import.meta.url).toString();

});

parcelRegister("6mj2Q", function(module, exports) {
module.exports = new URL("head-in-the-clouds.373b7817.png", import.meta.url).toString();

});

parcelRegister("cKCfP", function(module, exports) {
module.exports = new URL("time-2.e64cd78f.wav", import.meta.url).toString();

});

parcelRegister("5UOzC", function(module, exports) {
module.exports = new URL("another-npc.e4208ad6.wav", import.meta.url).toString();

});

parcelRegister("12UvK", function(module, exports) {
module.exports = new URL("soup.bd73cb7e.wav", import.meta.url).toString();

});

parcelRegister("kDEt5", function(module, exports) {
module.exports = new URL("the-wheel-of-fortune-1.f6fb1f29.wav", import.meta.url).toString();

});

parcelRegister("5ptAB", function(module, exports) {
module.exports = new URL("the-wheel-of-fortune-2.7301d747.wav", import.meta.url).toString();

});

parcelRegister("eT9hq", function(module, exports) {
module.exports = new URL("head-in-the-clouds.faf1c120.wav", import.meta.url).toString();

});

var $f2abf37f89819310$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["47h7s","tier-list.213501d5.js","l5IWp","time-2.fb93ff21.png","kYFZ9","another-npc.cb713ed6.png","hoJmq","soup.d80ca473.png","hGRzN","the-wheel-of-fortune.268f82f2.png","3aN9R","head-in-the-clouds.373b7817.png","injLD","time-2.e64cd78f.wav","fxv7D","another-npc.e4208ad6.wav","iUQdn","soup.bd73cb7e.wav","NNYXX","the-wheel-of-fortune-1.f6fb1f29.wav","5fKA9","the-wheel-of-fortune-2.7301d747.wav","fz5GY","head-in-the-clouds.faf1c120.wav","1Imnu","sus1.56b92f51.webp","6GsC6","sus2.42a61b5d.webp","8gMhm","sus3.3ae41f98.webp","gjniW","sus4.6077857d.webp","7B26D","social-credit.ce7ed3b0.webp"]'));


var $eBhjS = parcelRequire("eBhjS");

var $bHJUT = parcelRequire("bHJUT");

var $3UKTR = parcelRequire("3UKTR");

var $iQrU4 = parcelRequire("iQrU4");

var $6mj2Q = parcelRequire("6mj2Q");

var $cKCfP = parcelRequire("cKCfP");

var $5UOzC = parcelRequire("5UOzC");

var $12UvK = parcelRequire("12UvK");

var $kDEt5 = parcelRequire("kDEt5");

var $5ptAB = parcelRequire("5ptAB");

var $eT9hq = parcelRequire("eT9hq");
var $a66b047debc68bd8$exports = {};
$a66b047debc68bd8$exports = new URL("sus1.56b92f51.webp", import.meta.url).toString();


var $44c0c255296f2012$exports = {};
$44c0c255296f2012$exports = new URL("sus2.42a61b5d.webp", import.meta.url).toString();


var $bf02bbf295a2801c$exports = {};
$bf02bbf295a2801c$exports = new URL("sus3.3ae41f98.webp", import.meta.url).toString();


var $7537ea5465316244$exports = {};
$7537ea5465316244$exports = new URL("sus4.6077857d.webp", import.meta.url).toString();


var $af0de70280a78122$exports = {};
$af0de70280a78122$exports = new URL("social-credit.ce7ed3b0.webp", import.meta.url).toString();



const $bdb0072509be8b15$var$songs = [
    {
        id: "time-2",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($eBhjS))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cKCfP))),
        name: "time 2",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "another-npc",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($bHJUT))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5UOzC))),
        name: "when another npc tells u not to put ur student loan into shitcoin",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "soup",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($3UKTR))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($12UvK))),
        name: "soup (with sula)",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "the-wheel-of-fortune-1",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($iQrU4))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kDEt5))),
        name: "the wheel of fortune i",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "the-wheel-of-fortune-2",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($iQrU4))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5ptAB))),
        name: "the wheel of fortune ii",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "head-in-the-clouds",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($6mj2Q))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "head in the clouds",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "placeholder",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "placeholder",
        tempo: "120 BPM",
        key: "C",
        release: "01.01.01"
    },
    {
        id: "placeholder",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "placeholder",
        tempo: "120 BPM",
        key: "C",
        release: "01.01.01"
    },
    {
        id: "placeholder",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "placeholder",
        tempo: "120 BPM",
        key: "C",
        release: "01.01.01"
    },
    {
        id: "placeholder",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "placeholder",
        tempo: "120 BPM",
        key: "C",
        release: "01.01.01"
    }
];
//create songs
const $bdb0072509be8b15$var$songGrid = document.querySelector(".song-grid");
const $bdb0072509be8b15$var$colorButtons = document.querySelectorAll(".color-button");
const $bdb0072509be8b15$var$tierListRow = document.querySelectorAll(".tier-list-row");
//create random song order
$bdb0072509be8b15$var$songs.sort(()=>Math.random() - 0.5);
//create element
function $bdb0072509be8b15$var$createSongElement(songData) {
    const songElement = document.createElement("div");
    songElement.classList.add("song");
    songElement.setAttribute("draggable", "true");
    songElement.style.backgroundImage = `url(${songData.cover})`;
    $bdb0072509be8b15$var$songGrid.appendChild(songElement);
    return songElement;
}
let $bdb0072509be8b15$var$isPhone = window.innerWidth < 768;
let $bdb0072509be8b15$var$currentSong;
function $bdb0072509be8b15$var$createSongs() {
    if ($bdb0072509be8b15$var$isPhone) {
        $bdb0072509be8b15$var$currentSong = $bdb0072509be8b15$var$createSongElement($bdb0072509be8b15$var$songs[0]);
        $bdb0072509be8b15$var$songs.splice(0, 1);
    } else $bdb0072509be8b15$var$songs.forEach((songData)=>{
        $bdb0072509be8b15$var$createSongElement(songData);
    });
}
$bdb0072509be8b15$var$createSongs();
window.addEventListener("resize", $bdb0072509be8b15$var$handleSongs);
function $bdb0072509be8b15$var$handleSongs() {
    let phone = window.innerWidth < 768;
    if (phone !== $bdb0072509be8b15$var$isPhone) {
        $bdb0072509be8b15$var$songGrid.innerHTML = "";
        $bdb0072509be8b15$var$isPhone = window.innerWidth < 768;
        $bdb0072509be8b15$var$createSongs(); //if u resize
    }
}
//drag and drop
let $bdb0072509be8b15$var$draggedItem = null;
const $bdb0072509be8b15$var$item = document.querySelectorAll(".song");
const $bdb0072509be8b15$var$dropZone = document.querySelectorAll(".tier-list-row, .song-container");
const $bdb0072509be8b15$var$popupSection = document.querySelector(".popup-section");
document.addEventListener("dragstart", (event)=>{
    if (event.target.classList.contains("song")) {
        $bdb0072509be8b15$var$draggedItem = event.target;
        event.dataTransfer.effectAllowed = "move";
    }
});
document.addEventListener("dragover", (event)=>{
    if (event.target.classList.contains("tier-list-row") || event.target.classList.contains("song-container")) event.preventDefault();
});
document.addEventListener("drop", (event)=>{
    event.preventDefault();
    $bdb0072509be8b15$var$handleDrop(event.target);
});
function $bdb0072509be8b15$var$handleDrop(zone) {
    if ($bdb0072509be8b15$var$draggedItem) {
        if (zone.classList.contains("tier-list-row")) {
            $bdb0072509be8b15$var$tierListDrop(zone);
            if (zone.classList.contains("f-tier-row")) $bdb0072509be8b15$var$fPopup();
            if (zone.classList.contains("s-tier-row")) $bdb0072509be8b15$var$sPopup();
        } else {
            $bdb0072509be8b15$var$songGrid.appendChild($bdb0072509be8b15$var$draggedItem);
            $bdb0072509be8b15$var$draggedItem.style.width = "100%";
        }
        $bdb0072509be8b15$var$draggedItem = null;
    }
}
function $bdb0072509be8b15$var$tierListDrop(zone) {
    zone.appendChild($bdb0072509be8b15$var$draggedItem);
    $bdb0072509be8b15$var$draggedItem.style.width = "20%";
}
// buttons for phone
$bdb0072509be8b15$var$colorButtons.forEach((button, i)=>{
    button.addEventListener("click", ()=>{
        if (i === 0) $bdb0072509be8b15$var$sPopup();
        else if (i === 6) $bdb0072509be8b15$var$fPopup();
        console.log("clicked", i);
        console.log($bdb0072509be8b15$var$tierListRow[i]);
        $bdb0072509be8b15$var$tierListRow[i].appendChild($bdb0072509be8b15$var$currentSong);
        $bdb0072509be8b15$var$currentSong.style.width = "20%";
        $bdb0072509be8b15$var$createSongs();
    });
});
//popup
let $bdb0072509be8b15$var$popup;
function $bdb0072509be8b15$var$fPopup() {
    $bdb0072509be8b15$var$createPopup();
    $bdb0072509be8b15$var$popup.src = [
        (0, (/*@__PURE__*/$parcel$interopDefault($a66b047debc68bd8$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($44c0c255296f2012$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($bf02bbf295a2801c$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7537ea5465316244$exports)))
    ][Math.floor(Math.random() * 4)];
}
function $bdb0072509be8b15$var$sPopup() {
    $bdb0072509be8b15$var$createPopup();
    $bdb0072509be8b15$var$popup.src = (0, (/*@__PURE__*/$parcel$interopDefault($af0de70280a78122$exports)));
}
function $bdb0072509be8b15$var$createPopup() {
    const existingPopup = document.querySelector(".popup");
    if (existingPopup) existingPopup.remove();
    $bdb0072509be8b15$var$popup = document.createElement("img");
    $bdb0072509be8b15$var$popup.classList.add("popup");
    $bdb0072509be8b15$var$popupFadeOut($bdb0072509be8b15$var$popup);
    if (!$bdb0072509be8b15$var$isPhone) $bdb0072509be8b15$var$desktopPopup();
    else if ($bdb0072509be8b15$var$isPhone) $bdb0072509be8b15$var$phonePopup();
    return $bdb0072509be8b15$var$popup;
}
function $bdb0072509be8b15$var$desktopPopup() {
    $bdb0072509be8b15$var$popupSection.appendChild($bdb0072509be8b15$var$popup);
    $bdb0072509be8b15$var$popup.style.height = "100%";
}
function $bdb0072509be8b15$var$phonePopup() {
    document.body.appendChild($bdb0072509be8b15$var$popup);
    $bdb0072509be8b15$var$popup.style.width = "100%";
    $bdb0072509be8b15$var$popup.style.height = "100%";
    $bdb0072509be8b15$var$popup.style.position = "fixed";
    $bdb0072509be8b15$var$popup.style.top = "0";
    $bdb0072509be8b15$var$popup.style.left = "0";
}
function $bdb0072509be8b15$var$popupFadeOut(popup) {
    popup.style.opacity = 1;
    popup.style.transition = "opacity ease-in-out 2s";
    setTimeout(()=>{
        popup.style.opacity = 0;
        setTimeout(()=>{
            popup.remove(); // Remove after fade-out completes
        }, 2000); // 200ms delay + 200ms fade-out time
    }, 200);
}


//# sourceMappingURL=tier-list.213501d5.js.map
